import Tour from '@core/components/Tour';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import faturamentoApi from 'app/services/api/faturamentoApi';
import { usuarioApi } from 'app/services/api/usuarioApi';
import { visaoGeralApi } from 'app/services/api/visaoGeralApi';
import { GlobalContext } from 'app/store/globalcontext';
import { initializeReactGA } from 'app/utils/analyticsUtil';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Graficos from './Graficos';
import { ModaisTour } from './components/Modal/ModaisTour';
import ModalTour from './components/Modal/ModalTour';
import NotificacaoSistema from './components/NotificacaoSistema';
import { stepsVisaoGeral } from './components/steps/VisaoGeralSteps';
import { stepsWelcomeInicial } from './components/steps/WelcomeInicialSteps';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 24,
    paddingLeft: 24,
    paddingRight: 24,
    '@media(min-width: 1800px)': {
      paddingLeft: '20%',
      paddingRight: '20%',
    },
  },
  alert: {
    '&.MuiAlert-root': {
      fontFamily: 'Roboto',
      backgroundColor: '#ff9800',
    },
    '&>.MuiAlert-message': {
      color: '#fff',
      fontWeight: 500,
      backgroundColor: '#ff9800',
    },
    '&>.MuiAlert-icon': {
      color: '#fff',
    },
    flex: 1,
    marginBottom: '20px',
  },
}));

function VisaoGeral(props) {
  const classes = useStyles(props);
  // const { t } = useTranslation('visaoGeral');
  const [modalWelcomeInicial, setModalWelcomeInicial] = useContext(GlobalContext).modalWelcomeInicial;
  const [modalVisaoGeral, setModalVisaoGeral] = useContext(GlobalContext).modalVisaoGeral;
  const [funcionalidadesTour, setFuncionalidadesTour] = useContext(GlobalContext).funcionalidadesTour;
  const [visualizarDadosDashboard, setVisualizarDadosDashboard] = useContext(GlobalContext).visualizarDadosDashboard;

  const [notificarGeracaoRemessa, setNotificarGeracaoRemessa] = useState(false);
  const [notificarFaturamentoPendencias, setNotificarFaturamentoPendencias] = useState(false);
  const [notificarLimitePlanoNfe, setNotificarLimitePlanoNfe] = useState(false);
  const [notificarLimitePlanoNfse, setNotificarLimitePlanoNfse] = useState(false);
  const [runWelcomeInicial, setRunWelcomeInicial] = useState(false);
  const [runVisaoGeral, setRunVisaoGeral] = useState(false);
  const [notificarCertificadoVencido, setNotificarCertificadoVencido] = useState(false);
  const [notificarCertificadoProximoVencimento, setNotificarCertificadoProximoVencimento] = useState(false);
  const [dataValidade, setDataValidade] = useState(null);

  const history = useHistory();

  const fetchNotificarGeracaoRemessa = async () => {
    const resp = await visaoGeralApi.getNotificarGeracaoRemessa();

    setNotificarGeracaoRemessa(resp.data);
  };

  const fetchNotificarCertificadoDigital = async () => {
    const resp = await visaoGeralApi.getNotificarCertificadoDigital();

    if (resp.data?.vencido) {
      setNotificarCertificadoVencido(true);
    } else if (resp.data?.proximoDoVencimento) {
      setNotificarCertificadoProximoVencimento(true);
    }

    setDataValidade(moment(resp?.data?.dataValidade).format('DD/MM/YYYY'));
  };

  const fetchNotificarLimitePlanoNfe = async () => {
    const resp = await faturamentoApi.verificarLimitePlanoNfe();

    setNotificarLimitePlanoNfe(resp.data);
  };

  const fetchNotificarLimitePlanoNfse = async () => {
    const resp = await faturamentoApi.verificarLimitePlanoNfse();

    setNotificarLimitePlanoNfse(resp.data);
  };

  const fetchVerificarPendencias = async (date) => {
    const resp = await faturamentoApi.verificarPendencias(date);

    if (resp.data) {
      setNotificarFaturamentoPendencias(true);
    }
  };

  const onClickVerPendencias = () => {
    history.push({ pathname: '/financeiro/faturamento' }, { data: true });
  };

  const iniciarTour = async () => {
    const resp = await usuarioApi.buscarTour();
    setFuncionalidadesTour(resp.data);

    if (!resp.data?.some((f) => f === 'WELCOME_INICIAL')) {
      setModalWelcomeInicial(ModaisTour.modalWelcomeInicial);
    } else if (!resp.data?.some((f) => f === 'VISAO_GERAL')) {
      setModalVisaoGeral(ModaisTour.modalVisaoGeral);
    }
  };

  const buscarTourVisaoGeral = async () => {
    if (!funcionalidadesTour?.some((f) => f === 'VISAO_GERAL')) {
      setModalVisaoGeral(ModaisTour.modalVisaoGeral);
    }
  };

  const atualizarTourWelcomeInicial = async () => {
    let funcionalidades = funcionalidadesTour;
    if (!funcionalidadesTour) {
      setFuncionalidadesTour(['WELCOME_INICIAL']);
      funcionalidades = ['WELCOME_INICIAL'];
    } else {
      funcionalidades.push('WELCOME_INICIAL');
      setFuncionalidadesTour(funcionalidadesTour);
    }
    await usuarioApi.updateTour(funcionalidades);
    setRunWelcomeInicial(false);
  };

  const atualizarTourVisaoGeral = async () => {
    if (!funcionalidadesTour) {
      setFuncionalidadesTour(['VISAO_GERAL']);
    } else {
      funcionalidadesTour.push('VISAO_GERAL');
      setFuncionalidadesTour(funcionalidadesTour);
    }
    await usuarioApi.updateTour(funcionalidadesTour);
    setRunVisaoGeral(false);
  };

  const atualizarPermissaoDashboard = () => {
    if (!!visualizarDadosDashboard) {
      setVisualizarDadosDashboard(permissaoUtils.dashboard().visualizar);
    } else {
      setVisualizarDadosDashboard(false);
    }
  };

  useEffect(() => {
    initializeReactGA(history?.location?.pathname);
    fetchNotificarCertificadoDigital();
    fetchNotificarGeracaoRemessa();
    fetchVerificarPendencias(new Date().toISOString());
    fetchNotificarLimitePlanoNfe();
    fetchNotificarLimitePlanoNfse();
    atualizarPermissaoDashboard();
    iniciarTour();
    // Efeito de montagem: incluir as dependências reexecutaria a carga inicial a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const msgWelcomeInicial = `Olá, a partir de agora você poderá contar com a <br/> melhor solução de gestão para o seu negócio.
                             <br/>
                             Nos próximos passos, a cada primeiro acesso nas <br/> funcionalidades, 
                             vamos exibir um tour para <br/> apresentar os principais recursos do sistema e mostrar como é fácil a sua utilização.`;

  const msgVisaoGeral = `Pronto!
                         <br/>
                         Agora que você já conhece as funções do <br/> cabeçalho. Nos próximos passos, vamos te <br/> mostrar como é fácil fazer a 
                         gestão dos números <br/> analisando os gráficos disponíveis.`;

  return (
    <>
      <ModalTour
        open={modalWelcomeInicial === ModaisTour.modalWelcomeInicial}
        run={runWelcomeInicial}
        setRun={setRunWelcomeInicial}
        pathImg={'assets/images/tour/welcomeInicialTour.png'}
        conteudo={msgWelcomeInicial}
        isWelcomeInicial
      />
      <Tour
        steps={stepsWelcomeInicial}
        run={runWelcomeInicial}
        setRun={setRunWelcomeInicial}
        onFinish={() => {
          atualizarTourWelcomeInicial();
          buscarTourVisaoGeral();
        }}
      />
      {ModaisTour.modalVisaoGeral && (
        <>
          <ModalTour
            open={modalVisaoGeral === ModaisTour.modalVisaoGeral}
            run={runVisaoGeral}
            setRun={setRunVisaoGeral}
            pathImg={'assets/images/tour/visaoGeralTour.png'}
            conteudo={msgVisaoGeral}
          />
          <Tour
            steps={stepsVisaoGeral}
            run={runVisaoGeral}
            setRun={setRunVisaoGeral}
            onFinish={() => {
              atualizarTourVisaoGeral();
            }}
          />
        </>
      )}

      <Grid container className={classes.root} style={{ flexDirection: 'column' }}>
        <NotificacaoSistema exibir={notificarLimitePlanoNfe}>
          Sua empresa atingiu o limite máximo para emissão de NF-e. Entre em contato com nossa equipe caso queira
          renovar o seu plano comercial.
        </NotificacaoSistema>

        <NotificacaoSistema exibir={notificarLimitePlanoNfse}>
          Sua empresa atingiu o limite máximo para emissão de NFS-e. Entre em contato com nossa equipe caso queira
          renovar o seu plano comercial.
        </NotificacaoSistema>

        <NotificacaoSistema exibir={notificarGeracaoRemessa}>
          Existem cobranças a serem enviadas automaticamente, lembre-se de gerar remessa para o banco.
        </NotificacaoSistema>

        <NotificacaoSistema exibir={notificarCertificadoProximoVencimento}>
          O certificado digital está próximo do vencimento. Vencimento em {dataValidade}.
        </NotificacaoSistema>

        <NotificacaoSistema exibir={notificarCertificadoVencido}>
          O certificado digital está vencido. Vencimento em {dataValidade}.
        </NotificacaoSistema>

        {notificarFaturamentoPendencias && (
          <Alert severity="warning" className={classes.alert}>
            <div style={{ display: 'flex' }}>
              Alguns faturamentos não foram concluídos porque existem pendências de cadastro.
              <div onClick={onClickVerPendencias} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                Ver pendências.
              </div>
            </div>
          </Alert>
        )}

        <Graficos />
      </Grid>
    </>
    // <FusePageCarded
    //   classes={{
    //     root: classes.layoutRoot,
    //   }}
    //   contentToolbar={
    //     <div className="px-24">
    //       <h4>Visão Geral</h4>
    //     </div>
    //   }
    //   content={
    //     <div className="p-24">
    //     </div>
    //   }
    // />
  );
}

export default VisaoGeral;
